export default "__VITE_ASSET__Caj53gP$__";